<template>
	<div class="exam_left">
		<div class="left_wrap">
			<el-collapse style="overflow-y:auto;overflow-x:hidden;height:100%;" v-if="paperData !== null"
				v-model="activeNames">
				<el-collapse-item v-for="(data,index) in leftData" :title="`${ data.sectionAlias || data.sectionName}`" :name="index"
					:key="index">
					<ul class="topic_wrap">
						<li v-bind:title="item.selected" v-if="data.orderSort === 0"
							:class="[{active:num === item.id},{select:item.selected},{makeAnswer:item.makeAnswer}]"
							@click="setQuestion(item,item.id,index1,item.questionId)"
							v-for="(item,index1) in data.testPaperQuestionsList" class="topic_num" :key="index1">
							<div class="top">
								<span>{{index1+1}}</span><i v-if="item.selected && !item.makeAnswer"></i><i v-else-if="item.makeAnswer && (!item.selected || item.selected)">?</i><i v-else>*</i>
							</div>
							<p></p>
						</li>
						<li v-bind:title="item.selected" v-if="data.orderSort === 1"
							:class="[{active:num === item.id},{select:item.selected},{makeAnswer:item.makeAnswer}]"
							@click="setQuestion(item,item.id,index1,item.questionId)"
							v-for="(item,index1) in data.testPaperQuestionsList" class="topic_num" :key="index1">
							<div class="top">
								<span>{{index1+1}}</span><i v-if="item.selected && !item.makeAnswer"></i><i v-else-if="item.makeAnswer && (!item.selected || item.selected)">?</i><i v-else>*</i>
							</div>
							<p></p>
						</li>
						<li v-bind:title="item.selected" v-if="data.orderSort === 2"
							:class="[{active:num === item.id},{select:item.selected},{makeAnswer:item.makeAnswer}]"
							@click="setQuestion(item,item.id,index1,item.questionId)"
							v-for="(item,index1) in data.testPaperQuestionsList" class="topic_num" :key="index1">
							<div class="top">
								<span>{{index1+1}}</span><i v-if="item.selected && !item.makeAnswer"></i><i v-else-if="item.makeAnswer && (!item.selected || item.selected)">?</i><i v-else>*</i>
							</div>
							<p></p>
						</li>
						<li v-bind:title="item.selected" v-if="data.orderSort === 3"
							:class="[{active:num === item.id},{select:item.selected},{makeAnswer:item.makeAnswer}]"
							@click="setNoQuestion(item,item.id,index1,item.questionId)"
							v-for="(item,index1) in data.testPaperQuestionsList" class="topic_num" :key="index1">
							<div class="top">
								<span>{{index1+1}}</span><i v-if="item.selected && !item.makeAnswer"></i><i v-else-if="item.makeAnswer && (!item.selected || item.selected)">?</i><i v-else>*</i>
							</div>
							<p></p>
						</li>
					</ul>
				</el-collapse-item>
				<div class="left_footer">
					<p>说明：</p>
					<p>1.题目右方的“*”符号代表该小题尚未选择答案。</p>
					<p>2.题目右方的“?”符号代表该小题做过标记。</p>
					<p>3.选择选项的同时自动保存答案。</p>
				</div>
				<div class="jsq">
					<img src="../../../../../../static/images/testImgs/jsq.png" @click="jsqShow">
				</div>
			</el-collapse>
		</div>
		<!-- 计算器 -->
		<Calculator :isCalculatorShow="isCalculatorShow"/>
	</div>
</template>
<script>
	import * as api from "../../../../../api/testExamApi";
	import {
		moduleId
	} from "../../../../../store/modules/exam";
	import {
		mapState,
		mapMutations,
		mapActions,
		mapGetters
	} from 'vuex';
	import Calculator from "./calculator"
	export default {
		name: "examLeft",
		data() {
			return {
				activeNames: [0, 1, 2, 3, 4],
				num: 0,
				activeData: null,
				switchData: null,
				examPaperId: 0,
				leftDataList:[],
				isCalculatorShow: false,
				answerFlag: false
			};
		},
		components: {
			Calculator
		},
		created() {

			// api.classQuery(this.$route.query.classId).then((result) => {
			// 	console.log(result, 1111111111);
			// 	if (result.code === "0") {
			// 		localStorage.setItem("subjectId", result.data.subjectId);
					let obj = {
						"paperId": this.$route.query.paperId,
						// "subjectId": result.data.subjectId,
						"classId": this.$route.query.classId,
						"courseId": this.$route.query.id,
						"catalogId": this.$route.query.catalogId,
						"paperCode": this.$route.query.paperCode,
						"type": this.$route.query.type,
						"globalExamId": this.$route.query.examId
					}
					this.selectTestNew(obj).then((result) => {
						console.log(result);
						this.examPaperId = result.data.examPaperId
						if (result.code === "1") {
							this.$router.push({
								path: '/switch/test/stupreviewNew',
								query: {
									id: this.$route.query.id,
									classId: this.$route.query.classId,
									userId: sessionStorage.getItem('userId'),
									paperId: this.$route.query.paperId,
									finishFlag: 0
								}
							});
						} else if (result.code === "2") {
							this.$messageError(result.msg);
						} else if (result.code === "6") {
							this.$messageError(result.msg);
						}
						if (result.data.paperStructure !== "") {
							console.log(JSON.parse(result.data.paperStructure)[0].testPaperPartsList[0].testPaperSectionsList)
							this.SET_LEFT_DATA(JSON.parse(result.data.paperStructure)[0]
								.testPaperPartsList[0].testPaperSectionsList);
						} else {
							this.SET_LEFT_DATA(null);
							this.$messageError("试卷为空！");
						}
					});
			// 	} else if (result.code === "2" || result.code === "2") {
			// 		this.$messageError(result.msg);
			// 	}
			// })


		},
		computed: {
			...mapState(moduleId, {
				paperData: state => state.paperData,
				leftData: state => state.leftData,
				questionData: state => state.questionData,
				answer: state => state.paperData === null ? null : state.paperData.alreadyQuestion,
				success: state => state.success,
				makeAnswerSelect: state => state.paperData === null ? null : state.paperData.remarkQuestion,
				makeAnswerSelectEd: state => state.makeAnswer,
				preAnswers: state => state.preAnswer
			}),
		},
		watch: {
			leftData(newVal) {
				//乱序题号
				if (this.$route.query.isOutOfOrder == 1) {
					newVal.map((item) => {
						item.testPaperQuestionsList.sort(function(data) {
							//组合题不乱序
							if (item.internalTypeId === 6) {
								return false;
							} else {
								return Math.random() - 0.5;
							};

						});
					});
				}

				this.answer.forEach((item) => {
					this.leftData.forEach((data) => {
						if (data.testPaperQuestionsList) {
							data.testPaperQuestionsList.forEach((result) => {
								if (result.questionId === item.questionId) {
									result.selected = true;
								}
							})
						}

					})

				})
				//默认显示第一试题
				this.num = newVal === null ? 0 : newVal[0].testPaperQuestionsList[0].id;
				this.SET_QUESTION_DATA(newVal[0].testPaperQuestionsList[0]);
				let questionId = newVal === null ? 0 : newVal[0].testPaperQuestionsList[0].questionId;
				//显示第一道题的答案
				let obj = {
					"paperId": this.$route.query.paperId,
					"questionId": questionId,
					"userId": sessionStorage.getItem('userId'),
					"classId": this.$route.query.classId,
					"examPaperId": this.examPaperId
				};
				this.preAnswerNew(obj);


				//切换上一题，下一题数据
				let switchArray = [];
				newVal.forEach((item) => {
					item.testPaperQuestionsList.forEach((data) => {
						data.sectionPrompt = item.sectionPrompt;
						data.sectionName = item.sectionName;
						switchArray.push(data);
					})
				});
				let object = {
					data: switchArray,
					index: 0
				};
				this.switchData = object;
				this.SET_PAPER_LIST(object);


			},
			questionData(val) {
				this.num = val.id;
			},
			success(val) {
				console.log(val)
				if (val !== null) {
					if (val.status === 1) { //标记已做
						this.leftData.forEach((item) => {
							item.testPaperQuestionsList.forEach((data) => {
								if (data.questionId === val.questionId) {
									data.selected = true;
								}
							})
						});
					} else if (val.status === 0) { //取消标记
						this.leftData.forEach((item) => {
							item.testPaperQuestionsList.forEach((data) => {
								if (data.questionId === val.questionId) {
									data.selected = false;
								}
							})
						});
					}

				}
			},
			makeAnswerSelect(val) {
				let that = this;
				setTimeout(() => {
					val.forEach((item) => {
						that.leftData.forEach((data) => {
							data.testPaperQuestionsList.forEach((result) => {
								if (result.questionId === item) {
									result.makeAnswer = true;
								}
							})
						})
					})
					that.$forceUpdate()
				}, 500)


			},
			makeAnswerSelectEd(val) {
				this.leftData.forEach((item) => {
					item.testPaperQuestionsList.forEach((data) => {
						if (data.questionId === Number(val.substring(0, val.length - 1))) {
							if (val === data.questionId + "0") {
								data.makeAnswer = true;
							} else if (val === data.questionId + "1") {
								data.makeAnswer = false;
							}
						}
					})
				});
			}
		},
		methods: {
			...mapMutations(moduleId, ['SET_QUESTION_DATA', 'SHOW_OPTIONS', 'SET_PAPER_LIST', 'SAVE_ANSWER_SUCCESS',
				'SAVE_PRE_ANSWER', 'SET_LEFT_DATA','ARR_ANSWER','TERM_ANSWER'
			]),
			...mapActions(moduleId, ['selectTestNew', 'preAnswerNew']),
			setQuestion(item, id, index, questionId) {
				this.num = id;
				this.activeData = item;
				//当前试题数据
				this.SET_QUESTION_DATA(item);
				console.log(this.switchData)
				this.switchData.data.forEach((data, index) => {
					if (data.questionId === item.questionId) {
						this.switchData.index = index;
					}
				});
				this.SET_PAPER_LIST(this.switchData);

				//回显上次选择答案

				//上次选择的答案
				let obj = {
					"paperId": this.$route.query.paperId,
					"questionId": questionId,
					"userId": sessionStorage.getItem('userId'),
					"classId": this.$route.query.classId,
					"examPaperId": this.examPaperId
				};
				this.SAVE_PRE_ANSWER(null)
				this.preAnswerNew(obj).then((result) => {
					if (result.code === "0") {
						this.leftData.forEach((item) => {
							item.testPaperQuestionsList.forEach((data) => {
								if (data.questionId === obj.questionId) {
									if (result.data.answer == "remark") {
										data.selected = false;
									}else if(result.data.answer == ""){
										data.selected = false;
									}else{
										data.selected = true;
									}
								}
							})
						});

						this.$forceUpdate();
					}
				});
			},
			setNoQuestion(item, id, index, questionId){
				this.num = id;
				this.activeData = item;
				let promiseList = []
				let arr = []
				//当前试题数据
				this.SET_QUESTION_DATA(item);
				this.ARR_ANSWER(item.questionDto.childQuestions);
				this.switchData.data.forEach((data, index) => {
					if (data.questionId === item.questionId) {
						this.switchData.index = index;
					}
				});
				this.SET_PAPER_LIST(this.switchData);
				let qustItem = item;
				//回显答案
				[].forEach.call(item.questionDto.childQuestions,(item,index)=>{
					let obj = {
						"paperId": this.$route.query.paperId,
						"questionId": item.id,
						"userId": sessionStorage.getItem('userId'),
						"classId": this.$route.query.classId,
						"examPaperId": this.examPaperId
					};
					promiseList.push(this.preAnswerNew(obj))
				})
				Promise.all(promiseList).then(res=>{
					// 回显当前题目答案
					this.$set(qustItem,'selected',false);
					[].forEach.call(res,(key,index)=>{
						console.log(key.data.answer)
						let answer = key.data.answer
						if(answer){
							this.$set(qustItem,'selected',true)
						}else if(answer == "remark"){
							this.$set(qustItem,'selected',false)
						}
						arr.push(key.data)
						this.TERM_ANSWER(arr)
					})

					// 回显上一次题目
					this.$forceUpdate();
				})

			},
			jsqShow(){
				this.isCalculatorShow = !this.isCalculatorShow
			}
		},

		mounted() {

		}
	}
</script>

<style lang="scss" scoped>
	.exam_left {
		width: 328px;
		/*flex: 1;*/
		height: 100%;
		box-sizing: border-box;

		.left_wrap {
			width: 100%;
			height: 100%;
			background: white;
			position: relative;
			overflow: hidden;
			background: #EFF6FE;
			border: 1px solid #9FB7F7;

			/deep/ .el-collapse-item__wrap {
				background-color: #EFF6FE;
			}

			.topic_wrap {
				width: 100%;

				.topic_num {
					width: 30px;
					height: 30px;
					line-height: 25px;
					text-align: center;
					background: #DDEBF6;
					opacity: 1;
					color: #0055F5;
					font-size: 12px;
					float: left;
					margin-left: 10px;
					margin-top: 8px;
					margin-bottom: 8px;
					cursor: pointer;
					// &:hover{
					//   background:rgba(83,151,247,1);
					//   color: white;
					// }
				}

				.active{
				  background: #DCEAE1 !important;
				  color: white!important;
				}
				// .select{
				//   border: 1px solid rgba(83,151,247,0.7);
				//   color: #fff;
				//   background: rgba(83,151,247,0.7);
				// }
				li {
					display: flex;
					flex-direction: column;
					align-items: center;

					.top {
						width: 100%;
						display: flex;
						justify-content: space-around;

						span {
							font-size: 12px;
							color: #0052ED;
						}

						i {
							color: #FF0200;
							font-size: 12px;
							font-style: normal;
						}
					}

					p {
						width: 20px;
						height: 1px;
						background: #0052ED;
					}
				}
			}

			.left_footer {
				margin-left: 5px;

				p {
					font-size: 12px;
					color: #FF0200;
					line-height: 20px;
				}
			}
			.jsq {
				display: flex;
				justify-content: center;
				margin-top: 28px;
				img {
					display: inline-block;
					width: 98px;
					height: 38px;
					cursor: pointer;
				}
			}
			.student-information {
				width: 240px;
				height: 120px;
				background: rgba(255, 255, 255, 1);
				position: absolute;
				left: 0;
				bottom: 0;

				h1 {
					color: rgba(83, 151, 247, 1);
					font-size: 14px;
					margin-top: 9px;
					margin-left: 15px;
				}

				.student_item {
					width: 100%;
					height: 90px;
					margin-top: 9px;

					img {
						width: 70px;
						height: 85px;
						float: left;
						margin-left: 15px;
					}

					.student_list {
						float: left;
						margin-left: 14px;

						.student_number span:nth-child(1) {
							font-size: 14px;
							color: rgba(153, 153, 153, 1);
						}

						.student_number span:nth-child(2) {
							font-size: 14px;
							color: rgba(51, 51, 51, 1);
						}
					}
				}

				h2 {
					margin-top: 17px;

					.h_left {
						font-size: 14px;
						color: rgba(153, 153, 153, 1);
						margin-left: 15px;
					}

					.h_right {
						font-size: 14px;
						color: rgba(51, 51, 51, 1);
					}
				}
			}

			/deep/ .el-collapse-item__header {
				width: auto;
				height: 34px;
				background: linear-gradient(180deg, #7BBFEE 0%, #478EC4 100%);
				border-radius: 4px 4px 4px 4px;
				position: relative;
				margin-bottom: 8px;
				// border-left: 2px solid rgba(83,151,247,1);
				color: #000000;
				font-size: 14px;
				padding-left: 12px;
				line-height: 34px;
				height: 34px;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				font-weight: 600;
				text-align: center;
			}

			/deep/ .el-icon-arrow-right:before {
				color: rgba(255, 255, 255, 1);
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/testSumulationComponentNew/examLeft.vue